// extracted by mini-css-extract-plugin
export default {"footerText":"PopupWith2Buttons_footerText__RYFUl"};